// extracted by mini-css-extract-plugin
module.exports = {"content":"GraduationRequirements_content__2znD3","text":"GraduationRequirements_text__1hhmI"};